// @ai-generated 2026-08-24T11:41:43+00:00 by kai.cissarek@synqony.com using Claude Opus 5
import { compareForDisplay } from '@synqo/frontend-component-library';

/**
 * Orders searched candidates by the label the user reads. List routes answer in id order, which
 * arrives shuffled in a picker; `compareForDisplay` is numeric-aware, so "9" stays ahead of "10".
 */
export function sortByDisplayString<T extends { display_string: string }>(items: T[]): T[] {
    return [...items].sort((left, right) => compareForDisplay(left.display_string, right.display_string));
}
